export default __webpack_public_path__ + "images/VS.c4255d0.png";